import React from 'react';
import { useSelector } from 'react-redux';
import styles from '../Transaction/transaction.module.css';
import { formatDateV2, numberFormat } from '../../utils';
import { useHistory } from 'react-router-dom';
import { getAccountInfo } from '../../redux/actions/auth';

const MySubscriptionHistory = () => {
  const history = useHistory();

  const {
    user: {
      account: { subscriptions },
    },
  } = useSelector((state) => state.auth);

  const calculateExpirationDate = (date) => {
    const dateNow = new Date().getTime();
    const seconds = Math.floor((date - dateNow) / 1000); // in seconds
    const numberOfDays = Math.floor(seconds / 86400); //get days
    if (numberOfDays > 0 && numberOfDays < 30) {
      return `Expire in ${numberOfDays} days`;
    }
    if (numberOfDays > 0 && numberOfDays > 30) {
      return `Expire in: ${Math.floor(numberOfDays / 30)} months`;
    }
    return formatDateV2(date, 'dd mmm yyyy, hh:mm');
  };

  const onClickRenew = (subscription) => {
    history.push('/profile/subscription/buy-new');
  };

  const formatPriceDuration = (sub) => {
    if (sub.packageDuration || sub.packagePrice) {
      return `Rp ${numberFormat.format(sub.packagePrice)} for${' '}
    ${sub.packageDuration} ${sub.packageDurationType}${
        sub.packageDuration !== 1 ? 's' : ''
      }`;
    } else {
      return '';
    }
  };
  return (
    <div className={styles.listWrapper}>
      {subscriptions?.length === 0 && (
        <div className={styles.packagesWrapper}>
          <div className={styles.noData}>
            <div>No Active Subscription</div>
            <div>Your active subscription will show up here.</div>
          </div>
        </div>
      )}
      {subscriptions?.map((sub, key) => {
        return (
          <div className={styles.itemWrapper} key={key}>
            <div className={styles.detail}>
              <h3 className={styles.title}>{sub.packageName}</h3>
              <span className={`${styles.subtitle} ${styles.mt}`}>
                {formatPriceDuration(sub)}
              </span>

              {sub.endAt && (
                <span className={styles.amount}>
                  {sub?.endAt && calculateExpirationDate(sub?.endAt)}
                </span>
              )}
            </div>
            {sub.packagePrice && sub.packageDuration && (
              <button
                onClick={() => onClickRenew(sub)}
                className={styles.renewButton}
              >
                <span>Renew</span>
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MySubscriptionHistory;
